import { render, staticRenderFns } from "./msSegmented.vue?vue&type=template&id=6a3607e4&scoped=true"
import script from "./msSegmented.vue?vue&type=script&lang=js"
export * from "./msSegmented.vue?vue&type=script&lang=js"
import style0 from "./msSegmented.vue?vue&type=style&index=0&id=6a3607e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3607e4",
  null
  
)

export default component.exports